module.exports = __webpack_public_path__ + "static/media/Involved4.e9121d63.svg";